import React from 'react';
import PropTypes from 'prop-types';

const NavigationControls = ({ children }) => (children ? <div>{children}</div> : undefined);

NavigationControls.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.shape(), PropTypes.array]),
};

NavigationControls.defaultProps = {
  children: {},
};

export default NavigationControls;
